import { Button, Checkbox, Input, Modal, Popconfirm, Table } from "antd";
import { CREATE_jwel, tenantName } from "../../../Config/Config";
import axios from "axios";
import { useRef } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { HiOutlinePause } from "react-icons/hi";
import { FiRefreshCw, FiX, FiSearch } from "react-icons/fi";

// A few hover / nth-child / antd-internal overrides can't be expressed as
// inline style props in React, so they live in this one scoped <style> tag
// instead of a separate .css file. Everything else below is inline.
const scopedCss = `
  .hsd-modal .ant-modal-content { padding: 0; overflow: hidden; border-radius: 14px; }
  .hsd-modal .ant-modal-header { margin: 0; padding: 0; border-bottom: none; background: transparent; }
  .hsd-modal .ant-modal-body { padding: 0; }
  .hsd-icon-btn:hover { background: rgba(255,255,255,0.24) !important; }
  .hsd-search-pill:focus-within { border-color: #234a75 !important; box-shadow: 0 0 0 3px rgba(35,74,117,0.12); }
  .hsd-submit-btn:hover, .hsd-submit-btn:focus { background: #1c3a5e !important; color: #fff !important; }
  .hsd-table .ant-table-thead > tr > th { background: #eef2f7; color: #43536b; font-size: 12.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; border-bottom: 1px solid #e2e8f0; padding: 10px 14px; }
  .hsd-table .ant-table-tbody > tr > td { padding: 10px 14px; font-size: 13.5px; color: #33415c; border-bottom: 1px solid #f0f3f7; }
  .hsd-table .ant-table-tbody > tr:nth-child(even) > td { background: #fafbfd; }
  .hsd-table .ant-table-tbody > tr:hover > td { background: #eef4fa !important; }
  .hsd-del-btn:hover { background: #fde8e8 !important; }
`;

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "18px 24px",
    background: "linear-gradient(135deg, #1c3a5e 0%, #234a75 100%)",
    position: "relative",
    overflow: "hidden",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: 14, zIndex: 1 },
  headerIcon: {
    width: 38,
    height: 38,
    borderRadius: 10,
    background: "rgba(255,255,255,0.14)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    flexShrink: 0,
  },
  headerText: { display: "flex", flexDirection: "column", gap: 2 },
  headerTitle: { color: "#fff", fontSize: 16, fontWeight: 600, lineHeight: 1.2 },
  headerSubtitle: {
    color: "rgba(255,255,255,0.65)",
    fontSize: 12.5,
    lineHeight: 1.2,
  },
  headerActions: { display: "flex", alignItems: "center", gap: 8, zIndex: 1 },
  iconBtn: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    border: "none",
    background: "rgba(255,255,255,0.12)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  body: { padding: "18px 24px 22px", background: "#f7f9fb" },
  filters: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  searchPill: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 999,
    padding: "0 14px",
    height: 40,
    minWidth: 240,
  },
  searchIcon: { color: "#94a3b8", flexShrink: 0 },
  searchInput: { padding: 0, fontWeight: 600, fontSize: 14, color: "#1e293b" },
  submitBtn: {
    height: 40,
    padding: "0 22px",
    borderRadius: 999,
    border: "none",
    background: "#234a75",
    color: "#fff",
    fontWeight: 600,
    boxShadow: "none",
  },
  selectedStat: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginLeft: "auto",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 999,
    padding: "6px 8px 6px 18px",
    height: 40,
  },
  selectedLabel: { fontSize: 12.5, fontWeight: 600, color: "#64748b" },
  selectedValue: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1c3a5e",
    background: "#eaf1f8",
    borderRadius: 999,
    padding: "5px 14px",
    fontVariantNumeric: "tabular-nums",
  },
  tableCard: {
    background: "#fff",
    border: "1px solid #e9edf2",
    borderRadius: 12,
    overflow: "hidden",
  },
  sno: { color: "#94a3b8", fontWeight: 600 },
  holdnoChip: {
    display: "inline-block",
    fontWeight: 700,
    fontSize: 13.5,
    color: "#1c3a5e",
    background: "#eaf1f8",
    borderRadius: 6,
    padding: "2px 10px",
  },
  num: { fontVariantNumeric: "tabular-nums", fontWeight: 500 },
  numDiscount: { color: "#b45309" },
  numNet: { fontWeight: 700, color: "#1c3a5e" },
  muted: { color: "#a0aec0" },
  delBtn: {
    borderRadius: 8,
    width: 30,
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  empty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    padding: "24px 0",
  },
  emptyTitle: { fontWeight: 600, color: "#475569", fontSize: 14 },
  emptySub: { color: "#94a3b8", fontSize: 12.5 },
};

const HoldSelectDialog = ({
  holdOpen,
  setHoldOpen,
  holdData,
  setHoldData,
  filteredHoldData,
  setFilteredHoldData,
  selectedHoldRowKeys,
  handleSearchHoldInput,
  handleCheckboxChangeHold,
  handleReset,
  setSearchHoldText,
  searchHoldText,
  filterDataByHoldNo,
  setHNo,
  deleteBarcodeMastHoldAPI,
  deleteBarcodeDetHoldAPI,
  modifyHoldDetAPI,
  modifyHoldMastAPI,
  smCodeRef,
  //   billItemAPI,
  //   billPaymentsAPI,
  //   billCustLedgerAPI,
}) => {
  const searchInputRef = useRef(null);
  const submitBillNoRef = useRef(null);

  const handleDelete = (hold) => {
    deleteBarcodeMastHoldAPI(hold);
    deleteBarcodeDetHoldAPI(hold);
  };
  const handleHoldDelete = (billno) => {
    // remove from main data
    setHoldData((prev) => prev.filter((item) => item.billno !== billno));

    // remove from filtered data
    setFilteredHoldData((prev) =>
      prev.filter((item) => item.billno !== billno)
    );
  };

  const rows =
    filteredHoldData.length > 0 || searchHoldText ? filteredHoldData : holdData;

  const columns3 = [
    {
      title: "S.No",
      dataIndex: "sno",
      width: 50,
      key: "sno",
      align: "center",
      render: (_, __, index) => <span style={styles.sno}>{index + 1}</span>,
    },
    {
      title: "",
      dataIndex: "checkbox",
      width: 44,
      key: "checkbox",
      align: "center",
      render: (_, record) => (
        <Checkbox
          checked={selectedHoldRowKeys.includes(record.billno)}
          onChange={() => handleCheckboxChangeHold(record.billno)}
          onKeyDown={(e) => handleKeyDown(e, submitBillNoRef)}
        />
      ),
    },
    {
      title: "Hold No",
      dataIndex: "billno",
      key: "billno",
      render: (text) => <span style={styles.holdnoChip}>{text}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      width: 70,
      render: (_, record) => (
        <Popconfirm
          title="Are you sure you want to delete?"
          onConfirm={() => {
            handleDelete(record?.billno);
            handleHoldDelete(record?.billno);
          }}
          okText="Yes"
          cancelText="No"
        >
          <button type="button" className="hsd-del-btn" style={styles.delBtn}>
            <DeleteOutlined style={{ color: "#dc2626", fontSize: 15 }} />
          </button>
        </Popconfirm>
      ),
    },
    {
      title: "Cust Name",
      dataIndex: "CustName",
      key: "CustName",
      width: 260,
      render: (text) => text || <span style={styles.muted}>-</span>,
    },
    {
      title: "Mobile No",
      dataIndex: "PhoneNo",
      key: "PhoneNo",
      render: (text) => text || <span style={styles.muted}>-</span>,
    },
    {
      title: "Inv Date",
      dataIndex: "billdate",
      key: "billdate",
      render: (text) =>
        text ? (
          new Date(text).toLocaleDateString("en-GB").replace(/\//g, "-")
        ) : (
          <span style={styles.muted}>N/A</span>
        ),
    },
    {
      title: "Total Qty",
      dataIndex: "TOTQTY",
      key: "TOTQTY",
      align: "right",
      render: (text) => <span style={styles.num}>{text ?? 0}</span>,
    },
    {
      title: "Dis.Amt",
      dataIndex: "discount",
      key: "discount",
      align: "right",
      render: (text) => (
        <span style={{ ...styles.num, ...styles.numDiscount }}>
          {Number(text || 0).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Net Amt",
      dataIndex: "NETAMT",
      key: "NETAMT",
      align: "right",
      render: (text) => (
        <span style={{ ...styles.num, ...styles.numNet }}>
          {Number(text || 0).toFixed(2)}
        </span>
      ),
    },
  ];

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  const closeDialog = () => {
    setHoldOpen(false);
    handleReset();
    setSearchHoldText();
    filterDataByHoldNo();
    handleCheckboxChangeHold();
    smCodeRef.current?.focus();
  };

  return (
    <Modal
      open={holdOpen}
      onCancel={closeDialog}
      footer={null}
      width="80%"
      closeIcon={null}
      className="hsd-modal"
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(10, 20, 35, 0.35)",
      }}
      title={
        <div style={styles.header}>
          <style>{scopedCss}</style>
          <div style={styles.headerLeft}>
            <div style={styles.headerIcon}>
              <HiOutlinePause size={20} />
            </div>
            <div style={styles.headerText}>
              <span style={styles.headerTitle}>Hold Details</span>
              <span style={styles.headerSubtitle}>
                {rows.length} held bill{rows.length === 1 ? "" : "s"}
              </span>
            </div>
          </div>
          <div style={styles.headerActions}>
            <button
              type="button"
              className="hsd-icon-btn"
              style={styles.iconBtn}
              onClick={() => {
                setSearchHoldText();
                filterDataByHoldNo();
              }}
              title="Reset filters"
            >
              <FiRefreshCw size={15} />
            </button>
            <button
              type="button"
              className="hsd-icon-btn"
              style={styles.iconBtn}
              onClick={closeDialog}
              title="Close"
            >
              <FiX size={16} />
            </button>
          </div>
        </div>
      }
    >
      <div style={styles.body}>
        <div style={styles.filters}>
          <div className="hsd-search-pill" style={styles.searchPill}>
            <FiSearch style={styles.searchIcon} size={15} />
            <Input
              ref={searchInputRef}
              variant="borderless"
              placeholder="Search hold no..."
              value={searchHoldText}
              onChange={(e) => handleSearchHoldInput(e)}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => handleKeyDown(e, submitBillNoRef)}
              style={styles.searchInput}
            />
          </div>

          <Button
            ref={submitBillNoRef}
            className="hsd-submit-btn"
            style={styles.submitBtn}
            onClick={() => {
              modifyHoldDetAPI(searchHoldText);
              modifyHoldMastAPI(searchHoldText);
              setHNo(searchHoldText);
              setHoldOpen(false);
              smCodeRef.current?.focus();
            }}
          >
            Submit
          </Button>

          <div style={styles.selectedStat}>
            <span style={styles.selectedLabel}>Selected</span>
            <span style={styles.selectedValue}>
              {selectedHoldRowKeys?.length || 0}
            </span>
          </div>
        </div>

        <div style={styles.tableCard}>
          <Table
            dataSource={rows}
            columns={columns3}
            rowKey="billno"
            size="small"
            className="hsd-table"
            pagination={false}
            scroll={{ y: 300 }}
            locale={{
              emptyText: (
                <div style={styles.empty}>
                  <span style={styles.emptyTitle}>
                    {searchHoldText
                      ? "No matching hold bills"
                      : "No bills on hold"}
                  </span>
                  <span style={styles.emptySub}>
                    {searchHoldText
                      ? "Try a different hold number."
                      : "Held bills will show up here."}
                  </span>
                </div>
              ),
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HoldSelectDialog;